import { render, staticRenderFns } from "./cModalKitProduct.vue?vue&type=template&id=230de4db"
import script from "./cModalKitProduct.vue?vue&type=script&lang=js"
export * from "./cModalKitProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports